import React from 'react'
import Flights from 'Components/Home/icons/flights.svg'
import Hotels from 'Components/Home/icons/hotels.svg'
import Local from 'Components/Home/icons/local.svg'
import Trains from 'Components/Home/icons/trains.svg'
import Buses from 'SVGPath/bus.svg'

const tripTypeIcon = ({ tripDetails }) => {
  const { tripType } = tripDetails
  const fillColor = 'rgba(0, 0, 0, 0.3)'
  const width = '18px'
  const height = '18px'

  let tripIcon = null
  if (tripType === 'bus') {
    tripIcon = (
      <Buses fill={fillColor} width={width} height={height} />
    )
  } else if (tripType === 'train') {
    tripIcon = (
      <Trains fill={fillColor} width={width} height={height} />
    )
  } else if (tripType === 'hotel') {
    tripIcon = (
      <Hotels fill={fillColor} width={width} height={height} />
    )
  } else if (tripType === 'activity') {
    tripIcon = (
      <Local fill={fillColor} width={width} height={height} />
    )
  } else {
    tripIcon = (
      <Flights fill={fillColor} width={width} height={height} />
    )
  }
  return tripIcon
}

export default tripTypeIcon
